import { Header, HeroSlides, Layout, Listing, ProjectListing, People, Relationships, Solutions, ProcessFlow, Title, Wrapper, Endorsements, Services } from "components";
import React, { Component } from "react";
import "animate.css/animate.min.css";
import styled from "react-emotion";
import backgroundImage from '../shared/images/banner_blog.png';
import PropTypes from "prop-types";
import { graphql } from "gatsby";

const StyledProjects = styled.div`
`;

const StyledPosts = styled.div`
  padding-top: 2rem;
  padding-bottom: 0rem;
  background: url(${backgroundImage});
  background-repeat: no-repeat;
  background-position: right -300%;
  @media (max-width: ${props => props.theme.breakpoints.m}) {
    background: none;
  }
`;

const ScrollAnchorPoint = styled.div`
  position: relative;
  height: 0;
  top: -100px;
`;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      invert: false
    };
  }
  render() {
    const {
      data: { homepage, social, endorsements, posts, projects, projectCategories, profiles, relationships }
    } = this.props;
    return (
      <Layout>
        <Header invert={this.state.invert} />
        <HeroSlides slides={homepage.data} />
        <div style={{ background: 'white' }}>
        <ScrollAnchorPoint id='services' />
          <StyledProjects>
            <Wrapper>
              <Title>ENTERPRISE SOLUTIONS</Title>
              <h3 style={{ margin: 0 }}>Projects</h3>
              <ProjectListing projects={projects.edges} />
            </Wrapper>
          </StyledProjects>
          <Services />
          <Solutions projectCategories={projectCategories.edges} />
          <ScrollAnchorPoint id='why-bourne' />
          <ProcessFlow />
          <Relationships relationships={relationships} />
          <Endorsements endorsements={endorsements.data} />
          <ScrollAnchorPoint id='team' />
          <People profiles={profiles} limit={8} />
          <ScrollAnchorPoint id='blog' />
          <StyledPosts>
            <Wrapper>
              <h3>Blog</h3>
              <Listing posts={posts.edges} />
            </Wrapper>
          </StyledPosts>
        </div>
        <ScrollAnchorPoint id='footer-anchor' />
      </Layout>
    );
  }
}

export default Index;

Index.propTypes = {
  data: PropTypes.shape({
    posts: PropTypes.object.isRequired
  }).isRequired
};

export const pageQuery = graphql`
  query IndexQuery {
    homepage: prismicHomepage {
      data {
        title {
          text
        }
        tagline {
          text
        }
        content {
          html
        }
      }
    }
    profiles: allPrismicProfile {
      edges {
        node {
          uid
          data {
            first_name {
              text
            }
            last_name {
              text
            }
            position {
              text
            }
            bio {
              text
            }
            email {
              url
            }
            linkedin {
              url
            }
            group {
              uid
              document {
                id
                data {
                  name {
                    text
                  }
                }
              }
            }
            normal_photo {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
            fun_photo {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
          }
        }
      }
    }
    social: allPrismicHeroLinksBodyLinkItem {
      edges {
        node {
          primary {
            label {
              text
            }
            link {
              url
            }
          }
        }
      }
    }
    projectCategories: allPrismicProjectCategory {
      edges {
        node {
          uid
          data {
            name
            category_colour
            category_description {
              text
            }
            category_icon {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
            category_image {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
          }
        }
      }
    }
    posts: allPrismicPost(
      limit: 4
      sort: { fields: [data___date], order: DESC }
    ) {
      edges {
        node {
          uid
          data {
            title {
              text
            }
            date(formatString: "DD.MM.YYYY")
            thumbnail {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
            summary {
              text
            }
            categories {
              category {
                document {
                  data {
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    projects: allPrismicProject(
      limit: 3
      sort: { fields: [data___date], order: DESC }
    ) {
      edges {
        node {
          uid
          data {
            title {
              text
            }
            date(formatString: "DD.MM.YYYY")
            thumbnail {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
            client {
              text
            }
            summary {
              text
            }
            categories {
              projectcategory {
                document {
                  data {
                    name
                    category_colour
                  }
                }
              }
            }
          }
        }
      }
    }
    relationships: allPrismicRelationship {
      edges {
        node {
          uid
          data {
            name {
              text
            }
            relationship_type {
              uid
              document {
                id
                data {
                  relationship_category {
                    text
                  }
                }
              }
            }
            company_logo {
              localFile {
                childImageSharp {
                  fluid {
                    aspectRatio
                    src
                    srcSet
                    sizes
                  }
                }
              }
            }
          }
        }
      }
    }
    endorsements: prismicEndorsements {
      data {
        endorsement_1 {
          text
        }
        attribution_1 {
          text
        }
        image_1 {
          localFile {
            childImageSharp {
              fluid {
                aspectRatio
                src
                srcSet
                sizes
              }
            }
          }
        }
        endorsement_2 {
          text
        }
        attribution_2 {
          text
        }
        image_2 {
          localFile {
            childImageSharp {
              fluid {
                aspectRatio
                src
                srcSet
                sizes
              }
            }
          }
        }
        endorsement_3 {
          text
        }
        attribution_3 {
          text
        }
        image_3 {
          localFile {
            childImageSharp {
              fluid {
                aspectRatio
                src
                srcSet
                sizes
              }
            }
          }
        }
      }
    }
  }
`;
